var React = require('react');

function WebpackInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M68.148 60.255L36.64 78V64.18l19.631-10.752 11.877 6.827zm2.155-1.943v-37.11l-11.53 6.625V51.68l11.53 6.633zM2.366 60.255L33.874 78V64.18L14.243 53.427 2.367 60.255zM.211 58.312v-37.11l11.53 6.625V51.68L.21 58.312zM1.56 18.801L33.874.599V13.96L13.172 25.298l-.157.09L1.56 18.801zm67.395 0L36.64.599V13.96L57.342 25.3l.158.09 11.454-6.59zm-35.08 42.235L14.507 50.434V29.425L33.874 40.56v20.476zm2.765 0l19.367-10.602V29.425L36.64 40.56v20.476zM15.818 26.994l19.443-10.647 19.443 10.647-19.443 11.18-19.443-11.18z"}));
}

WebpackInline.defaultProps = {"viewBox":"0 0 71 78"};

module.exports = WebpackInline;

WebpackInline.default = WebpackInline;
